'use client';

import React from 'react';

type DynamicHideBlockProps = {
  data?: any;
  children: React.ReactNode;
};

const hasContent = (value: any): boolean => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.trim() !== '';
  if (typeof value === 'number') return true;
  if (Array.isArray(value)) {
    return value.some(hasContent);
  }
  if (typeof value === 'object') {
    return Object.values(value).some(hasContent);
  }
  return false;
};

export default function DynamicHideBlock({
  data,
  children,
}: DynamicHideBlockProps) {
  if (!hasContent(data)) return null;

  return <>{children}</>;
}
